import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export function Layout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-[#F9FAF8]">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function PageHeader({ title, subtitle, eyebrow, accent }) {
  return (
    <div className="bg-[#0B0B0C] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {eyebrow && (
          <p className="font-semibold uppercase tracking-widest text-xs mb-3" style={{ color: accent || "#E23744" }} data-testid="page-eyebrow">
            {eyebrow}
          </p>
        )}
        <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight" data-testid="page-title">
          {title}
        </h1>
        {subtitle && <p className="mt-4 text-gray-300 max-w-2xl text-lg leading-relaxed">{subtitle}</p>}
      </div>
    </div>
  );
}
